import $ from 'jquery'

import emitter from 'scripts/utils/emitter'
import BaseComponent from 'scripts/components/base-component'
import { tracker } from 'scripts/react-components/utils/app'
import { showSpinner, hideSpinner } from 'scripts/utils/spinner'
import tokenNotify from 'scripts/utils/account/token-notifier'
import {
  pushDataLayerForErrorLogin,
  dispatchLoginToDataLayer,
  pushDataObject
} from 'scripts/utils/data-layer'

class SignIn extends BaseComponent {
  static componentName = 'sign-in'

  static DOMEvents = {
    submit: 'onSubmit'
  }

  static emitterEvents = {
    'recaptcha:success': 'submitForm'
  }

  constructor (element, location = window.location) {
    super(element)
    this.location = location
    this.allowSubmit = true
  }

  init () {
    this.$feedbackWarning = this.$element.find('[data-feedback-warning]')
    this.getFormValidation()
    this.submitButton = this.$element.find('button')
  }

  getFormValidation () {
    if (this.validation) {
      return
    }

    this.validation = this.$element.data('validation')
  }

  onSubmit (e) {
    e.preventDefault()

    if (this.validation.validateAll()) {
      if (this.$element.data('recaptchaDisabled') === 1 && this.allowSubmit) {
        this.submitButton.prop('disabled', true)
        this.allowSubmit = false
        return this.submitForm()
      }

      emitter.emit('recaptcha:execute')
    }
  }

  submitForm () {
    const action = this.$element.attr('action')
    const data = this.$element.serialize()

    const xhrConfig = {
      data,
      method: 'POST',
      dataType: 'json',
      xhrFields: {
        withCredentials: true
      }
    }

    showSpinner()

    $.ajax(action, xhrConfig)
      .done(this.onSubmitSuccess.bind(this))
      .fail(response => {
        emitter.emit('recaptcha:submit-error')
        pushDataLayerForErrorLogin(this.getLabelError(response).join())
        this.onSubmitWarning(response)
      })
      .always(() => {
        setTimeout(() => {
          this.allowSubmit = true
          this.submitButton.prop('disabled', false)
        }, 1000)
      })
  }

  onSubmitSuccess (response) {
    const { status, errors, hybris, redirectUrl } = response
    const dataObject = dispatchLoginToDataLayer(response)

    if (status === 'error') {
      emitter.emit('recaptcha:submit-error')
      return this.displayError(errors)
    }

    if (hybris) {
      return this.requestHybrisCookie(hybris, redirectUrl)
    }

    tokenNotify()
    pushDataObject(dataObject)
    tracker.login('site')

    this.$feedbackWarning.addClass('hidden')
    this.location.replace(redirectUrl || this.location.href)
  }

  requestHybrisCookie (response, redirect) {
    const { token, url } = response

    const xhrConfig = {
      crossDomain: true,
      headers: {
        Authorization: token
      },
      xhrFields: {
        withCredentials: true
      }
    }

    $.ajax(url, xhrConfig)
      .fail(() => {
        const error = new Error('Problema no login', arguments)
      })
      .always(this.onHybrisCookieResponse.bind(this, redirect))
  }

  onHybrisCookieResponse (redirect) {
    this.location.replace(redirect)
  }

  onSubmitWarning (response) {
    let errors

    if (response.responseJSON && response.responseJSON.errors) {
      errors = response.responseJSON.errors
    } else {
      errors = {
        error: ['Por favor, tente novamente mais tarde.']
      }
    }

    this.displayError(errors)
  }

  displayError (errors) {
    hideSpinner()
    const $response = this.$feedbackWarning.find('.response')

    $response.html('')

    $.each(errors, (key, val) => {
      val.map(message => $response.append(`${message}<br>`))
    })

    this.$feedbackWarning.removeClass('hidden')
  }

  getLabelError (response) {
    const errorMapped = {
      'Nome de usuário ou senha incorretos.': 'invalid_credentials'
    }

    const errors = response?.responseJSON?.errors

    const error = []

    $.each(errors, (key, val) => {
      error.push(val.map(error => errorMapped[error] ?? 'others'))
    })

    return error !== [] ? error : 'others'
  }
}

export default $el => new SignIn($el).init()

export { SignIn as Component }
